import { SessionState } from 'reducers/session'

export interface AuthResponse {
  errorCode?: AuthErrorCodes
  sessionData: SessionState | null
  email?: string
}

export enum AuthErrorCodes {
  SsoUserNotLinked = 'PC-API-AUTH-23',
}
